import {create} from "zustand/react";

export interface YearFilterState {
  drawerOpen: boolean;
  selected: string[];
  openDrawer: () => void;
  closeDrawer: () => void;
  toggle: (year: string) => void;
}

export const useYearFilterState = create<YearFilterState>((set) => ({
  drawerOpen: false,
  selected: [],
  openDrawer: () => {
    set(() => ({drawerOpen: true}));
  },
  closeDrawer: () => {
    set(() => ({drawerOpen: false}));
  },
  toggle: (year: string) => {
    set(state => {
      if (state.selected.indexOf(year) < 0) {
        state.selected.push(year)
      } else {
        state.selected.splice(state.selected.indexOf(year), 1)
      }
      return {selected: [...state.selected]};
    })
  }
}))